module.exports = __webpack_public_path__ + "static/img/05.9c4da90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner/05.png
// module id = tQrx
// module chunks = 1